import React from 'react';
import ScheduledAgents from '../../../ScheduledAgents';

const SECTIONS = [
  {
    label: 'Scheduled Runners',
    value: 'scheduledAgents',
    component: <ScheduledAgents />,
    pathname: '/automation/schedule'
  }
];

export default SECTIONS;
